import { v4 as uuidv4 } from "uuid";

/**
 * Genera un UUID v4 criptográficamente seguro compatible con Capacitor, React Native y navegadores.
 * Utiliza el paquete estándar 'uuid' que hace uso interno de la Web Crypto API (crypto.getRandomValues).
 */
export function generateUUID(): string {
  return uuidv4();
}
